import React from 'react'

import PropTypes from 'prop-types'

import './announcement.css'

const Announcement = (props) => {
  return (
    <a
      href="https://www.500k.ro/"
      target="_blank"
      rel="noreferrer noopener"
      className="announcement-link"
    >
      <div
        className={`announcement-thq-announcement-elm ${props.rootClassName} `}
      >
        <div className="announcement-container">
          <span className="announcement-thq-title-elm1">{props.title11}</span>
          <span className="announcement-thq-title-elm2">{props.title12}</span>
          <div className="announcement-thq-button-elm">
            <span className="announcement-thq-button-text-elm">
              {props.button1}
            </span>
          </div>
        </div>
      </div>
    </a>
  )
}

Announcement.defaultProps = {
  title11: "We're celebrating an important milestone!",
  rootClassName: '',
  title12: "We're celebrating!",
  button1: 'Get a cool t-shirt ->',
}

Announcement.propTypes = {
  title11: PropTypes.string,
  rootClassName: PropTypes.string,
  title12: PropTypes.string,
  button1: PropTypes.string,
}

export default Announcement
